const postCloneEquipmentModels = {
  toastr: 'Tipo de equipo clonado',
  toastr1: ' fue agregado con éxito',
  toastrError: 'Nombre ya registrado',
  toastrError1: 'Ingrese otro nombre'
};

export default postCloneEquipmentModels;
